import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getCohortBuilderPath } from '@verantos-dev/core-constants';
import { useResearchAssistantSocketContext } from '@verantos-dev/feature-research-assistant';

interface UseNavigateAfterRevertInputs {
  projectId: string | undefined;
  cohortId: string | undefined;
  cohortVersionId: string | undefined;
}

/**
 * On AV edit page, a successful revert wipes the AV out of the cohort
 * definition (or restores it to a prior shape), so staying on this page
 * shows stale data. Listen for `cohort_reverted` and bounce back to the
 * cohort builder definition tab.
 */
export const useNavigateAfterRevert = ({
  projectId,
  cohortId,
  cohortVersionId,
}: UseNavigateAfterRevertInputs) => {
  const navigate = useNavigate();
  const { socket } = useResearchAssistantSocketContext();

  useEffect(() => {
    if (!socket || !projectId || !cohortId || !cohortVersionId) return;

    const handleCohortReverted = () => {
      navigate(`${getCohortBuilderPath(projectId, cohortId, cohortVersionId)}?pageTab=definition`);
    };

    socket.on('cohort_reverted', handleCohortReverted);
    return () => {
      socket.off('cohort_reverted', handleCohortReverted);
    };
  }, [socket, navigate, projectId, cohortId, cohortVersionId]);
};
